module.exports = __webpack_public_path__ + "static/monei_pay_group_es_2-e3a2f3afc4031e1cd0369bd4f2a85671.png";